module.exports = __webpack_public_path__ + "static/photoalbuminside-3339932968087854572815b4c22dcf8f.jpeg";